import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/dianzi-youxi', label: '游戏分类' },
    { to: '/category/xin-pin-tuijian', label: '新品推荐' },
    { to: '/about', label: '关于我们' },
  ];

  const bgClass = isScrolled || !isHome
    ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
    : 'bg-transparent';

  const textClass = isScrolled || !isHome
    ? 'text-foreground-900'
    : 'text-white';

  const logoTextClass = isScrolled || !isHome
    ? 'text-foreground-900'
    : 'text-white';

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${bgClass}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className={`flex items-center gap-2 ${logoTextClass} transition-colors duration-300`}>
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-gamepad-line text-white text-lg"></i>
            </div>
            <span className="font-heading font-bold text-lg md:text-xl whitespace-nowrap">{siteInfo.name}</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.to
                    ? isScrolled || !isHome
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : `${textClass} hover:bg-background-200/40`
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className={`px-5 py-2 rounded-lg text-sm font-medium border transition-all duration-200 whitespace-nowrap ${
                isScrolled || !isHome
                  ? 'border-primary-500 text-primary-600 hover:bg-primary-50'
                  : 'border-white/60 text-white hover:bg-white/10'
              }`}
            >
              登录
            </a>
            <a
              href="#"
              className="px-5 py-2 rounded-lg text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              免费注册
            </a>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg ${textClass}`}
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-2 pt-2 border-t border-background-200">
              <a href="#" className="flex-1 text-center px-4 py-2.5 rounded-lg text-sm font-medium border border-primary-500 text-primary-600 whitespace-nowrap">
                登录
              </a>
              <a href="#" className="flex-1 text-center px-4 py-2.5 rounded-lg text-sm font-medium bg-primary-500 text-white whitespace-nowrap">
                免费注册
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}